import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";

export const SchemaLocalBusiness = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "LocalBusiness",
        name: replaceSnappTripBasedOnChannel("اسنپ تریپ"),
        image: `${getOrigin()}/logo.png`,
        ...(isChannel(["snapp-ir"])
          ? {
              address: {
                "@type": "PostalAddress",
                streetAddress: "زعفرانیه",
                addressLocality: "Tehran",
                addressRegion: "Tehran Province",
                addressCountry: "IR"
              }
            }
          : { address: "Tehran Province, Tehran, Mehrdad, QCCC+977, Iran" }),
        geo: {
          "@type": "GeoCoordinates",
          latitude: isChannel(["snapp-ir"]) ? 35.8049 : 35.770_918_1,
          longitude: isChannel(["snapp-ir"]) ? 51.4166 : 51.418_097_8
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            opens: "09:00",
            closes: "18:00",
            dayOfWeek: [
              "Saturday",
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ]
          }
        ],
        telephone: "02196669066",
        priceRange: "IRR"
      })
    }}
    type="application/ld+json"
  />
);
